__turbopack_context__.v({
  "tooltip__trigger__mob": "tooltip-module__JKm_IG__tooltip__trigger__mob",
  "tooltip__trigger__web": "tooltip-module__JKm_IG__tooltip__trigger__web",
  "tp": "tooltip-module__JKm_IG__tp",
});
